import RootStore from './RootStore';

export const rootState = new RootStore();
export const gQ = rootState.gQ; //Questa
export const routes = rootState.routes; //Routes